export default __webpack_public_path__ + "static/media/i011hp.3c74dc8b.webp";